import { getCurrentUser, syncUser } from 'api/auth'
import { setUser } from 'store/authReducer'
import { storeAccessToken } from 'utils/authToken'

/** Sync user to DB, swap NBSS token for BorderDB token (contains user_id), put user into Redux. */
export const establishSession = async (dispatch) => {
  await syncUser()
  const { user, access_token } = await getCurrentUser()
  storeAccessToken(access_token)
  dispatch(setUser(user))
  return user
}
